import _keyBy from 'lodash/keyBy';
import { gerarAmbienteUrl } from './Pages/Vendas/helpers';

const packageJson = require('../package.json');

export const AUTH_KEY = 'AUTH_KEY';
export const HN = 'hn';
export const DEFAULT_ENV = 'prod';
export const USER = 'idsession';
export const ATENDENTE_LANCAMENTO = 'atendente_lancamento';
export const CARACTERISTICAS = 'caracteristicas';
export const MESA_ATENDIMENTO_SESSAO = 'mesa_atendimento_sessao';
export const ATENDIMENTO_ATIVO = 'atendimento_ativo';
export const CORRETOR_DESLIGADO = 'corretor_desligado';
export const SENHA_PADRAO_RESET = 'mudar';
export const APIBASE = gerarAmbienteUrl(false, true);
export const QUANTIDADEPORPAGINA = 10;

// W-0852 — Simula Comissão Cobrança (Pro-Fit, simulador read-only, RBAC literal: só autenticado)
export const ROTA_SIMULA_COMISSAO_COBRANCA = '/cobranca/simula-comissao-cobranca';
export const URL_LOGIN = `${process.env.PUBLIC_URL}/login`; // Utilizado para redirecionamento quando a sessão expirar
export const URL_BASE = process.env.PUBLIC_URL;
export const MASTER_VERSION = `${packageJson.version}`;
export const urlAdmVendas = `${gerarAmbienteUrl(
  true
)}/Comercial/AdministracaoVendas.aspx`;

export const REPOSITORIO_URL =
  process.env.REACT_APP_REPOSITORIO_URL || 'https://repositorio.setcorp.com.br';

export const GOOGLE_CALENDAR_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CALENDAR_CLIENT_ID || '';

export const MICROSOFT_CALENDAR_CLIENT_ID =
  process.env.REACT_APP_MICROSOFT_CALENDAR_CLIENT_ID || '';

export const PROVEDOR_CALENDARIO_EXTERNO = {
  NENHUM: 'Nao',
  GOOGLE: 'Google',
  OUTLOOK: 'Outlook',
};

export const TIME_ZONE_PADRAO_AGENDA = 'America/Sao_Paulo';

export let EMPREENDIMENTO_LANCAMENTO = 0;
export let SEGUNDO_EMPREENDIMENTO_LANCAMENTO = 0;
export function setEmpreendimentoLancamento(valor) {
  EMPREENDIMENTO_LANCAMENTO = valor;
}
export const STATUS_CODE_OK = 200;
export const USUARIO_AUTO = 1;

export const ENV = [
  { value: 'prod', label: 'Produção' },
  { value: 'hml', label: 'Homologação' },
  { value: 'dev', label: 'Desenvolvimento' },
];

export const TIPO_PESSOA = [
  { value: 0, label: 'Pessoa Física' },
  { value: 1, label: 'Pessoa Jurídica' },
];

export const PERFIL_COMPRADOR = [
  { value: 2, label: 'Morador' },
  { value: 1, label: 'Construtor' },
  { value: 3, label: 'Investidor' },
  { value: 4, label: 'Exterior' },
];

export const DESCRICOES_STATUS_COMPROVANTE = [
  { value: 0, label: 'Aguardando recebimento', cor: '#006400' },
  { value: 1, label: 'Aguardando comprovante', cor: '#ffc516' },
  { value: 2, label: 'Comprovante inserido', cor: '#3baf56' },
  { value: 3, label: 'Aprovado Sec. Vendas', cor: '#1E8BFF' },
  { value: 4, label: 'Aprovado Dpto. Financeiro', cor: '#619dd8' },
  { value: 8, label: 'Recusado Dpto. Financeiro', cor: '#ea9384' },
  { value: 9, label: 'Recusado', cor: '#dc3545' },
];

export const ERROS = {
  CPF_INDISPONIVEL: 'CPF já cadastrado',
  CPF_INVALIDO: 'CPF inválido, verifique',
  CPF_VINCULADO:
    'Não é possível alterar o CPF, entre em contato com a Sec. Vendas.',
  EMPREENDIMENTO_VINCULO_INVALIDO:
    'Prospecto não vinculado a um empreendimento válido. Tente vincular o prospecto a outro empreendimento.',
};

export const NIVELADM = 'ADM';
export const NIVELCOR = 'COR';
export const NIVELGER = 'GER';
export const NIVELCAV = 'CAV';

export const HIE_NIVEL = {
  EF7892F77C74F4C0: NIVELADM,
  C382AF9E0F00AAAD: NIVELCOR,
  '289C55969055E344': NIVELGER,
  A1B2C3D4E5F60789: NIVELCAV,
};

export const TIPO_PERIODO_ESPECIFICO = 'Especifico';
export const TIPO_PERIODO_ESTOQUE = 'Estoque';
export const TIPO_PERIODO_LANCAMENTO = 'Lancamento';
export const TIPO_PERIODO = [
  { value: TIPO_PERIODO_ESPECIFICO, label: 'Específico' },
  { value: TIPO_PERIODO_ESTOQUE, label: 'Apenas Estoque' },
  { value: TIPO_PERIODO_LANCAMENTO, label: 'Apenas Lançamento' },
];

export const TIPO_VISAO_RANKING = [
  { value: 0, label: 'Vendas - VGV' },
  { value: 1, label: 'Vendas - Unidade' },
  { value: 2, label: 'Rescisões - VGV' },
  { value: 3, label: 'Rescisões - Unidade' },
  { value: 4, label: 'Recebíveis' },
  { value: 5, label: 'Quantidade Atendimentos Leads' },
  { value: 6, label: '% Conversão Atendimento' },
  { value: 7, label: 'Comissão Projetada' },
  { value: 8, label: 'Vendas - Efetivadas' },
];

export const TIPO_PESSOA_FISICA = TIPO_PESSOA[0];
export const TIPO_PESSOA_JURIDICA = TIPO_PESSOA[1];
export const TAMANHO_CPF = 11;
export const TAMANHO_CEP = 8;

export const TIPO_CADASTRO = [
  { value: 0, label: 'Sem Documentos' },
  { value: 1, label: 'Incompleto' },
  { value: 2, label: 'Completo' },
  { value: 3, label: 'Conferido' },
];

export const SEXO = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' },
];

export const ESTADOS = [
  { value: 'AC', label: 'Acre' },
  { value: 'AL', label: 'Alagoas' },
  { value: 'AM', label: 'Amazonas' },
  { value: 'AP', label: 'Amapá' },
  { value: 'BA', label: 'Bahia' },
  { value: 'CE', label: 'Ceará' },
  { value: 'DF', label: 'Distrito Federal' },
  { value: 'ES', label: 'Espírito Santo' },
  { value: 'GO', label: 'Goiás' },
  { value: 'MA', label: 'Maranhão' },
  { value: 'MG', label: 'Minas Gerais' },
  { value: 'MS', label: 'Mato Grosso do Sul' },
  { value: 'MT', label: 'Mato Grosso' },
  { value: 'PA', label: 'Pará' },
  { value: 'PB', label: 'Paraíba' },
  { value: 'PE', label: 'Pernambuco' },
  { value: 'PI', label: 'Piauí' },
  { value: 'PR', label: 'Paraná' },
  { value: 'RJ', label: 'Rio de Janeiro' },
  { value: 'RN', label: 'Rio Grande do Norte' },
  { value: 'RO', label: 'Rondônia' },
  { value: 'RR', label: 'Roraima' },
  { value: 'RS', label: 'Rio Grande do Sul' },
  { value: 'SC', label: 'Santa Catarina' },
  { value: 'SE', label: 'Sergipe' },
  { value: 'SP', label: 'São Paulo' },
  { value: 'TO', label: 'Tocantins' },
];

export const ORGAO_EMISSOR_CNH = [
  { value: 'DETRAN/AC', label: 'DETRAN/AC' },
  { value: 'DETRAN/AL', label: 'DETRAN/AL' },
  { value: 'DETRAN/AM', label: 'DETRAN/AM' },
  { value: 'DETRAN/AP', label: 'DETRAN/AP' },
  { value: 'DETRAN/BA', label: 'DETRAN/BA' },
  { value: 'DETRAN/CE', label: 'DETRAN/CE' },
  { value: 'DETRAN/DF', label: 'DETRAN/DF' },
  { value: 'DETRAN/ES', label: 'DETRAN/ES' },
  { value: 'DETRAN/GO', label: 'DETRAN/GO' },
  { value: 'DETRAN/MA', label: 'DETRAN/MA' },
  { value: 'DETRAN/MG', label: 'DETRAN/MG' },
  { value: 'DETRAN/MS', label: 'DETRAN/MS' },
  { value: 'DETRAN/MT', label: 'DETRAN/MT' },
  { value: 'DETRAN/PA', label: 'DETRAN/PA' },
  { value: 'DETRAN/PB', label: 'DETRAN/PB' },
  { value: 'DETRAN/PE', label: 'DETRAN/PE' },
  { value: 'DETRAN/PI', label: 'DETRAN/PI' },
  { value: 'DETRAN/PR', label: 'DETRAN/PR' },
  { value: 'DETRAN/RJ', label: 'DETRAN/RJ' },
  { value: 'DETRAN/RN', label: 'DETRAN/RN' },
  { value: 'DETRAN/RO', label: 'DETRAN/RO' },
  { value: 'DETRAN/RR', label: 'DETRAN/RR' },
  { value: 'DETRAN/RS', label: 'DETRAN/RS' },
  { value: 'DETRAN/SC', label: 'DETRAN/SC' },
  { value: 'DETRAN/SE', label: 'DETRAN/SE' },
  { value: 'DETRAN/SP', label: 'DETRAN/SP' },
  { value: 'DETRAN/TO', label: 'DETRAN/TO' },
];

export const ESTADO_CIVIL_CLIENTE = [
  { value: 0, label: 'Solteiro' },
  { value: 1, label: 'Casado em regime de comunhão de bens' },
  { value: 2, label: 'Casado em regime de comunhão parcial de bens' },
  { value: 3, label: 'Casado em regime de comunhão universal de bens' },
  { value: 4, label: 'Casado em regime de participação final nos aquestos' },
  { value: 5, label: 'Casado em regime de separação total de bens' },
  { value: 6, label: 'União Estável' },
  { value: 7, label: 'Divorciado' },
  { value: 8, label: 'Separado Judicialmente' },
  { value: 9, label: 'Viúvo' },
];

export const ESTADO_CIVIL_CS = [
  { value: 1, label: 'Cônjuge / Rep. Legal' },
  { value: 2, label: 'Sócio' },
  { value: 3, label: 'Cônjuge do sócio' },
  { value: 4, label: 'Outros' },
  { value: 5, label: 'Procurador' },
  { value: 6, label: 'Cônjuge do procurador' },
];

export const PROSPECTO_STATUS_ENUM = {
  novo_lead: 1,
  qualificacao: 2,
  requalificacao: 3,
  recepcao_corretor: 4,
  em_atendimento: 5,
  visita: 6,
  montagem_de_pasta: 7,
  pasta_completa: 8,
  venda_realizada: 9,
  descartado: 10,
  reativacao: 11,
  pre_lancamento: 12,
  fila_do_lote: 13,
  qualificacao_corretor: 14,
  proposta: 15,
};

export const PROSPECTO_STATUS = [
  { value: PROSPECTO_STATUS_ENUM.novo_lead, label: 'Novo Lead' },
  { value: PROSPECTO_STATUS_ENUM.qualificacao, label: 'Qualificação' },
  {
    value: PROSPECTO_STATUS_ENUM.requalificacao,
    label: 'Requalificação',
  },
  {
    value: PROSPECTO_STATUS_ENUM.recepcao_corretor,
    label: 'Recepção Corretor',
  },
  { value: PROSPECTO_STATUS_ENUM.em_atendimento, label: 'Em Atendimento' },
  { value: PROSPECTO_STATUS_ENUM.visita, label: 'Visita' },
  {
    value: PROSPECTO_STATUS_ENUM.montagem_de_pasta,
    label: 'Montagem de Pasta',
  },
  { value: PROSPECTO_STATUS_ENUM.pasta_completa, label: 'Pasta Completa' },
  { value: PROSPECTO_STATUS_ENUM.venda_realizada, label: 'Venda Realizada' },
  { value: PROSPECTO_STATUS_ENUM.descartado, label: 'Descartado' },
  { value: PROSPECTO_STATUS_ENUM.reativacao, label: 'Reativação' },
  { value: PROSPECTO_STATUS_ENUM.pre_lancamento, label: 'Pré-lançamento' },
  { value: PROSPECTO_STATUS_ENUM.fila_do_lote, label: 'Fila do lote' },
  {
    value: PROSPECTO_STATUS_ENUM.qualificacao_corretor,
    label: 'Qualificação Corretor',
  },
  { value: PROSPECTO_STATUS_ENUM.proposta, label: 'Proposta' },
];

export const STATUS_ETAPAS_PROSPECTOS = [
  {
    codigo: 1,
    descricao: 'Novo Lead',
    pagina_atual: 1,
  },
  {
    codigo: 2,
    descricao: 'Qualificação',
    pagina_atual: 1,
  },
  {
    codigo: 3,
    descricao: 'Requalificação',
    pagina_atual: 1,
  },
  {
    codigo: 4,
    descricao: 'Recepção Corretor',
    pagina_atual: 1,
  },
  {
    codigo: 14,
    descricao: 'Qualificação Corretor',
    pagina_atual: 1,
  },
  {
    codigo: 5,
    descricao: 'Em Atendimento',
    pagina_atual: 1,
  },
  {
    codigo: 15,
    descricao: 'Proposta',
    pagina_atual: 1,
  },
  {
    codigo: 12,
    descricao: 'Pré-lançamento',
    pagina_atual: 1,
  },
  {
    codigo: 6,
    descricao: 'Visita',
    pagina_atual: 1,
  },
  {
    codigo: 13,
    descricao: 'Fila do lote',
    pagina_atual: 1,
  },
  {
    codigo: 7,
    descricao: 'Montagem de Pasta',
    pagina_atual: 1,
  },
  {
    codigo: 8,
    descricao: 'Pasta Completa',
    pagina_atual: 1,
  },
  {
    codigo: 9,
    descricao: 'Venda Realizada',
    pagina_atual: 1,
  },
  {
    codigo: 10,
    descricao: 'Descartado',
    pagina_atual: 1,
  },
  {
    codigo: 11,
    descricao: 'Reativação',
    pagina_atual: 1,
  },
];

export const STATUS_ETAPAS_PROSPECTOS_TERRENO_CONSTRUCAO = [
  { codigo: 1, descricao: 'Primeiro contato' },
  { codigo: 2, descricao: 'Captação' },
  { codigo: 3, descricao: 'Não respondeu 1º contato' },
  { codigo: 4, descricao: 'Agenda futura' },
  { codigo: 5, descricao: 'Follow Up' },
  { codigo: 6, descricao: 'Simulação' },
  { codigo: 7, descricao: 'Documentação' },
  { codigo: 8, descricao: 'Condicionado' },
  { codigo: 9, descricao: 'Organizar renda' },
  { codigo: 10, descricao: 'Rating' },
  { codigo: 11, descricao: 'Aprovado' },
  { codigo: 12, descricao: 'Negociando' },
  { codigo: 13, descricao: 'Desistiu' },
  { codigo: 14, descricao: 'Não responde mais' },
];

export const PROSPECTO_ORIGEM_CADASTRO = [
  { value: 1, label: 'Revo CRM' },
  { value: 2, label: 'Lead' },
  { value: 3, label: 'Hotsite' },
];

export const TIPOS_PESQUISA = {
  DISSERTATIVA: 'DISSERTATIVA',
  ESCOLHA: 'ESCOLHA',
  PESO: 'PESO',
  ESTRELA: [10],
};

export const TIPO_TITULO = {
  BOLETO: 1,
  CHEQUE: 2,
  DINHEIRO: 3,
  CARTAO: 4,
  DEPOSITO: 5,
  DUPLICATA: 6,
};

export const TIPO_ATIVIDADE = {
  TODOS: 999,
  ANOTACAO: 1,
  EMAIL: 2,
  TAREFA: 3,
  SMS: 4,
  VISITA: 5,
  WHATSAPP: 6,
  LIGACAO: 7,
};

export const FORMAS_PAGAMENTO = [
  { value: TIPO_TITULO.BOLETO, label: 'Boleto' },
  { value: TIPO_TITULO.CHEQUE, label: 'Cheque' },
  { value: TIPO_TITULO.CARTAO, label: 'Cartão' },
  { value: TIPO_TITULO.DEPOSITO, label: 'Deposito/PIX' },
  { value: TIPO_TITULO.DINHEIRO, label: 'Dinheiro' },
];

export const FORMAS_PAGAMENTO_BY_CODIGO = _keyBy(FORMAS_PAGAMENTO, 'value');

export const BOLETO = FORMAS_PAGAMENTO[0].value;
export const CHEQUE = FORMAS_PAGAMENTO[1].value;
export const CARTAO = FORMAS_PAGAMENTO[2].value;
export const DEPOSITO = FORMAS_PAGAMENTO[3].value;
export const DINHEIRO = FORMAS_PAGAMENTO[4].value;

export const DIAS_TOLERANCIA_VENCIMENTO_CHEQUE_DEPOSITO = 10;

export const TIPO_HISTORICO_PROPOSTA_RAPIDA = {
  INCLUSAO_DOCUMENTO: 1,
  REMOCAO_DOCUMENTO: 2,
  APROVACAO: 3,
  RECUSA: 4,
  RECEBIMENTO_APROVADO: 5,
  BAIXA_CONFIRMADA: 6,
  PENDENTE: 7,
};

export const TIPO_HISTORICO_PROPOSTA_RAPIDA_CORES = [
  {
    value: TIPO_HISTORICO_PROPOSTA_RAPIDA.INCLUSAO_DOCUMENTO,
    color: '#1E8BFF',
  },
  { value: TIPO_HISTORICO_PROPOSTA_RAPIDA.REMOCAO_DOCUMENTO, color: '#17A2B8' },
  { value: TIPO_HISTORICO_PROPOSTA_RAPIDA.APROVACAO, color: '#28A745' },
  { value: TIPO_HISTORICO_PROPOSTA_RAPIDA.RECUSA, color: '#dc3545' },
  {
    value: TIPO_HISTORICO_PROPOSTA_RAPIDA.RECEBIMENTO_APROVADO,
    color: '#28A745',
  },
  { value: TIPO_HISTORICO_PROPOSTA_RAPIDA.BAIXA_CONFIRMADA, color: '#28A745' },
  { value: TIPO_HISTORICO_PROPOSTA_RAPIDA.PENDENTE, color: '#FFC107' },
];

export const QUESTION_MAX_LENGTH = { id: 11, length: 5000 };

export const MASK_DATE = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const MASK_NUMERO_CARTAO = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const MASK_VALIDADE_CARTAO = [/\d/, /\d/, '/', /\d/, /\d/];
export const MASK_CPF = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];
// DW-0963: CNPJ alfanumérico — 12 posições alfanuméricas (0-9, A-Z) + 2 DV numéricos.
// Consumidores (Prospectos, Procurações) passam a aceitar CNPJ alfanumérico via esta máscara.
// Retrocompatível: dígitos continuam aceitos (CNPJ numérico mascara idêntico).
export const MASK_CNPJ = [
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '.',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '.',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '/',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '-',
  /\d/,
  /\d/,
];
export const MASK_CNPJ_ALFANUMERICO = MASK_CNPJ;
export const MASK_CEP = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
export const MASK_CEL = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d?/,
];

export const MASK_CEL_10 = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const MASK_CEL_11 = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const MASK_CNJ = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  '.',
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const DATE_DEFAULT_FORMAT = 'DD/MM/YYYY';
export const DATETIME_DEFAULT_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const DATETIME_DEFAULT_SHORT_FORMAT = 'DD/MM/YYYY HH:mm';
export const DATETIME_DEFAULT_SUPER_SHORT_FORMAT = 'DD/MM HH:mm';
export const DATE_FORMAT_SERVER = 'YYYY-MM-DDTHH:mm:ss';

export const CODIGO_TIPO_PROSPECTO = 1; // Utilizado no cadastro do prospecto para apontar que não é um sócio ou conjuge

export const CODIGO_ORIGEM_CADASTRO_PROSPECTO = 1; // Descreve que o prospecto cadastrado originou do Revo CRM

export const MAX_SIZE_DOCUMENTO = 7 * 1024 * 1024; // 7MB em bytes

export const TIPO_UPLOAD_PDF = 'application/pdf';
export const TIPOS_UPLOAD_DOCUMENTO_PROSPECTO = [TIPO_UPLOAD_PDF, 'image/*'];

export const PERGUNTAS_PARENTES = {};

//Pusher
export const pusherConfig = {
  id: '26537dd9c4f052c7a7f2',
  cluster: 'us2',
};

//Audio Senha
export const audio1 = '/audio/definite.ogg';
export const audio2 = '/audio/allusive.ogg';
export const audio3 = '/audio/alarm-frenzy.ogg';
export const audio4 = '/audio/long-chime-sound.ogg';

//Documento Digital
export const TiposGruposDocumentoDigital = {
  Compradores: 1,
  Testemunhas: 2,
  Procuradores: 3,
  Validadores: 4,
  Intervenientes: 5,
};

export const TiposSignatarios = {
  Assinante: 0,
  Parte: 1,
  Testemunha: 2,
  Procurador: 3,
  Aprovador: 4,
};

export const StatusDocumentoDigital = {
  NovaSolicitacao: 0,
  Solicitado: 1,
  Aprovado: 2,
  Reprovado: 3,
  Descartado: 4,
  PendenteAssinaturasClientes: 5,
  PendenteAssinaturasSetpar: 6,
  Cancelado: 7,
  Finalizado: 8,
  Uploaded: 9,
  Implantado: 10,
};

export const TipoEventoDocumentoDigital = {
  Solicitacao: 1,
  SignatarioVinculado: 2,
  SignatarioDesvinculado: 3,
  Reprovacao: 4,
  Descarte: 5,
  ReSolicitacao: 6,
  Aprovacao: 7,
  Upload: 8,
  NotificacaoEnviada: 9,
  AssinaturaRealizada: 10,
  Cancelamento: 11,
  Finalizacao: 12,
  SignatarioEditado: 13,
  IncluirCartaDesconto: 14,
  Implantado: 15,
  SolicitacaoCancelamentoDocDigital: 16,
};

export const TiposDocDigital = {
  ContratoVenda: 1,
  CLDB: 2,
  RefinanciamentoAditamento: 3,
  RescisaoRepasse: 4,
  RescisaoBilateral: 5,
  TransferenciaTitularidade: 6,
  Cessao: 8,
};

export const CorEventoDocDigital = [
  {
    value: TipoEventoDocumentoDigital.Solicitacao,
    color: '#20c997',
  },
  { value: TipoEventoDocumentoDigital.SignatarioVinculado, color: '#17A2B8' },
  {
    value: TipoEventoDocumentoDigital.SignatarioDesvinculado,
    color: '#ffc107',
  },
  { value: TipoEventoDocumentoDigital.Reprovacao, color: '#dc3545' },
  { value: TipoEventoDocumentoDigital.Cancelamento, color: '#dc3545' },
  { value: TipoEventoDocumentoDigital.Descarte, color: '#6c757d' },
  { value: TipoEventoDocumentoDigital.Aprovacao, color: '#28A745' },
  { value: TipoEventoDocumentoDigital.Upload, color: '#007bff' },
  { value: TipoEventoDocumentoDigital.Finalizacao, color: '#28A745' },
  { value: TipoEventoDocumentoDigital.AssinaturaRealizada, color: '#17A2B8' },
  { value: TipoEventoDocumentoDigital.IncluirCartaDesconto, color: '#28A7CE' },
  { value: TipoEventoDocumentoDigital.Implantado, color: '#007bff' },
  {
    value: TipoEventoDocumentoDigital.SolicitacaoCancelamentoDocDigital,
    color: '#FFD700',
  },
];

export const DescricoesTiposDocDigital = {
  [TiposDocDigital.ContratoVenda]: 'Contrato de Venda',
  [TiposDocDigital.CLDB]: 'Contrato de CLDB',
  [TiposDocDigital.RefinanciamentoAditamento]: 'Refinanciamento/Aditamento',
  [TiposDocDigital.RescisaoBilateral]: 'Rescisão Bilateral',
  [TiposDocDigital.RescisaoRepasse]: 'Rescisão para Repasse',
  [TiposDocDigital.TransferenciaTitularidade]: 'Transferência de Titularidade',
};

export const gruposContratoVenda = [
  {
    codigo: TiposGruposDocumentoDigital.Compradores,
    tipo: TiposGruposDocumentoDigital.Compradores,
    nome: 'compradores',
    seguir_ordem_interna: false,
    todos_devem_assinar: true,
  },
  {
    codigo: TiposGruposDocumentoDigital.Procuradores,
    tipo: TiposGruposDocumentoDigital.Procuradores,
    nome: 'procuradores',
    seguir_ordem_interna: false,
    todos_devem_assinar: false,
    minimo_assinaturas: 1,
  },
  {
    codigo: TiposGruposDocumentoDigital.Testemunhas,
    tipo: TiposGruposDocumentoDigital.Testemunhas,
    nome: 'testemunhas',
    seguir_ordem_interna: false,
    todos_devem_assinar: false,
    minimo_assinaturas: 2,
  },
  {
    codigo: TiposGruposDocumentoDigital.Validadores,
    tipo: TiposGruposDocumentoDigital.Validadores,
    nome: 'validadores',
    seguir_ordem_interna: false,
    todos_devem_assinar: false,
    minimo_assinaturas: 1,
  },
];

export const recorrenciaDuracoes = {
  anual: 12,
  semestral: 6,
  quadrimestral: 4,
  trimestral: 3,
  avulsa: 12,
};

export const StatusImovel = {
  Disponivel: 0,
  Vendido: 1,
  Bloqueado: 2,
  PreVenda: 3,
  PropostaRapida: 4,
  Reservado: 5,
  EmNegociacao: 6,
  VendaEspecial: 7,
  Repasse: 8,
};

export const caracteristicas = {
  // W-0431: Manutenção de Usuários
  ManutencaoUsuario: 5,
  // W-0972: Cadastro de Imobiliárias
  CadastraImobiliaria: 637,
  VisualizaUsuarioCorretor: 612,
  // W-0608: tela unificada de usuários — somente leitura (sem botões de escrita)
  SomenteConsultaUsuarios: 661,
  LancamentoMoedaCapital: 12,
  SecVendas: 277,
  TransfereReserva: 453,
  ExclusaoSocioConjuge: 555,
  ManutencaoDocDigital: 556,
  ConsultaDocDigital: 557,
  VisualizarContratoCompilado: 558,
  DocDigitalSolicitarCanc: 561,
  FaseConstrucao: 564,
  AlteraTextoContrato: 572,
  AtendenteCav: 570,
  GerencialSismac: 440,
  AtribuicaoAssinaturaDocDigital: 588,
  TelaAutoatendimentoEscritura: 591,
  Sis_parametros: 18,
  Assessor: 201,
  Rel_Comissao: 224,
  GerencialVendas: 20, // W-0483: Gerenciais Vendas
  CentralVenda: 199,
  AprovaCEDOC: 593,
  HabilitaInteresseSocial: 601,
  VisualizaContratoConstrucao: 602,
  // W-0240: FAQ
  GerenciaAssuntoFaq: 603,
  CavMaster: 605,
  // W-0426: Portador Usuário
  PortadorUsuario: 615,
  // W-0437: Log de Atualizações
  LogAtualizacoes: 616,
  // W-0438: Grupo de Empresas
  AlteraStatusGE: 293,
  AlteraStatusGE2: 316,
  AlteraPercentualSetpar: 502,
  RestringeEmpreendimentos: 621,
  // W-0234: Tabela de Preço e Qualidade do Ativo
  TabelaPreco: 617,
  ExcluirTabelaPreco: 618,
  StatusNuloCorrecao: 522,
  AtualizaQualidade: 285,
  AtualizaAtivo: 35,
  // W-0473: Manutenção de Ativos
  AlterarAtivos: 15,
  AlterarPedras: 91,
  AlterarMoedas: 92,
  AlterarImobilizados: 93,
  AlterarImoveis: 94,
  AlterarAnimal: 96,
  AlteraStatusImovel: 108,
  JurosDescImoveis: 113,
  ValidarCotacao: 378,
  AtualizaDocumento: 539,
  AtualizaParcelas: 538,
  SupervisorGED: 257,
  // W-0443: Cadastro de Contas (GES)
  ManutencaoObservacoes: 23,
  ConsultaObservacoes: 24,
  ManutencaoTipoContas: 25,
  ManutencaoInternet: 26,
  ForcaLancamento: 36,
  AlterarContaCliente: 49,
  AlterarDadosCliente: 50,
  ManutencaoDespesa: 383,
  BancoAgenciaRepetido: 488,
  VincularProspecto: 543,
  CancelarSolicitacaoCessao: 633,
  // Procuracoes
  AcessaProcuracoes: 627,
  EditaProcuracoes: 628,
  // W-0470: Categorias de Departamento
  CategoriaDepartamento: 629,
  // W-0471: Cadastro de Departamentos
  MatricialControladoria: 261,
  // W-0484: Negativação Interna de Cliente
  NegativacaoInternaCliente: 388,
  // W-0492: Parcerias
  Parcerias: 235,
  // W-0514: Cotações
  AlterarCotacao: 48,
  // W-0521: Relatório Despesa por Departamento
  RelDespesaDepto: 21,
  // W-0620: GES > Relatórios > Despesas > Analítico de despesas
  RelDespesasAnalitico: 21,
  // W-0467: Famílias de Ativos
  CriarAlterarFamilia: 170,
  // W-0482: Empreendimento (Imob > Comercial)
  TabelaPrecosImoveis: 129,
  EmpreendimentoComercial: 187,
  EmpreendimentoOperacional: 188,
  EmpreendimentoAdmVendas: 186,
  EmpreendimentoCaptacao: 207,
  EmpreendimentoComissao: 215,
  EmpreendimentoProjeto: 225,
  EmpreendimentoImobiliaria: 485,
  AlteraDiasTolerancia: 185,
  AtivoBoleto: 294,
  AtivoRepasse: 319,
  TransfereComissao: 290,
  // W-0476: Consulta Mapa Empreendimento
  BloquearImovel: 64,
  BloquearImovelUsuario: 251,
  ReservaEspecial: 379,
  VinculaPropostaVenda: 182,
  // W-0525: Cidades CRUD + Relatório
  ManutencaoCidades: 19,
  // W-0536: Rastreamento de Títulos (GES)
  RastreamentoTitulos: 85,
  // W-0537: Atualiza vencimento de títulos
  ManutencaoTitulo: 85,
  // W-0488: Consulta de Ocorrências de Contas
  ConsultaOcorrenciasContas: 119,
  // SP21: gate de visibilidade das telas migradas do ERP Delphi
  MigracaoERP: 630,
  // W-0991: Aprova Venda com Pendência Jurídica
  AprovaVendaPendenciaJuridica: 669,
  // W-0626: Relatório Demonstrativo Financeiro / Carteira (operador 2026-06-09)
  RelatDemonstrativoFinanceiro: 705,
  // W-0541: Contas bloqueadas no extrato
  LiberaExtrato: 14,
  // W-0485: Redutores e Descontos para Venda
  CadastrarRedutor: 448,
  LiberaDescontoVenda: 239,
  // W-0494: GES > Contas > Tabelas > Contas de Salário
  AcessoSalario: 375,
  // W-0500: Vínculo de Despesa com Tipo de Pagamento
  VinculoDespesaTipoPagamento: 573,
  // W-0515: Comunicado de Quitação (Enviadas)
  ListaComunicadoQuitacao: 525,
  // W-0962: Controle de Contrato (SupervisorGED 257 reusa entrada acima)
  ControleContrato: 101,
  ExcluirContrato: 120,
  MudarFase: 540,
  // W-0495: Solicitação de Débitos Municipais e Atualização Cadastral
  RespDebMunicipaisCond: 372,
  // Consulta Acesso — ver só senha do cliente do ambiente atual (oculta login)
  SenhaClienteAmbiente: 656,
  // W-0544: GES > Contas > Tabelas > Tipo de Conta Interna
  ManutencaoTipoContaInterna: 642,
  AcessoTelaCessao: 668,
  // W-0496: Remanejamento de Caixas
  RemanejamentoCaixa: 475,
  // W-0497: Cobrança SMS (Imob Cobrador)
  CobrancaImovel: 86,
  // W-0730: Envio de SMS Jurídico (Imob Jurídico)
  EnvioSmsJuridico: 693,
  CobradorGerencial: 123,
  CobradorOperacional: 124,
  // W-0759 — Imóveis em Estoque (Relatório Comercial Imob).
  // VALUE-GATE: operador confirmou a promoção para produção em 2026-07-27.
  // Char 724 = "Relat Imoveis em Estoque"; o portão transitório 630 não se aplica mais.
  ImoveisEstoque: 724,
};

// W-0502 — Validador Assinatura Digital
export const CARACTERISTICA_VALIDADOR_ASSINATURA_DIGITAL = 530;

// W-0730 — Envio de SMS Jurídico (ADR-007, Q-07=A)
export const CARACTERISTICA_ENVIO_SMS_JURIDICO = 693;
export const SMS_JURIDICO_MAX_CHARS = 160;
export const SMS_JURIDICO_CHUNK_SIZE = 50;
export const TIPOS_DISPARO_SMS = ['PorContrato', 'PorCpf'];

// W-0659 — Exportação e Importação de Cotação Moeda Forte (Gate 1B Q-01: código 644)
export const CARACT_EXP_IMP_COTACAO_MOEDA_FORTE = 644;
export const ROUTE_EXP_IMP_COTACAO_MOEDA_FORTE =
  '/ges/ferramentas/exportacao-importacao-cotacao-moeda-forte';

// W-0652 — Altera Nome Ativo (reusa caracteristicas.AtualizaAtivo=35; gate de migração char 630)
export const ROUTE_ALTERA_NOME_ATIVO = '/ges/ferramentas/altera-nome-ativo';
// W-0535 — Consulta CGC/CPF (Títulos)
export const CARACTERISTICA_CONSULTA_CGC_CPF = 27;
// W-0962 — Controle de Contrato (alias standalone para links.js / Routes/index.js)
export const CARACT_CONTROLE_CONTRATO = 101;
export const CARACTERISTICA_CONTROLE_HORAS_PJ = 663;
export const CARACTERISTICA_EDITA_EXCLUI_FECHAMENTO_PJ = 716;
// Cotação Moeda Forte
export const CARACT_RELATORIO_COTACAO_MOEDA_FORTE = 48;
export const ROUTE_COTACOES_MOEDA_FORTE = '/cotacoes-moeda-forte';

// W-0525 — Cidades
export const ROUTE_CIDADES = '/cadastros/cidades';

// W-0536 — Rastreamento de Títulos (GES)
export const CARACTERISTICA_RASTREAMENTO_TITULOS = 85;
// W-0533 — Manutenção de Títulos (GES): mesma característica Delphi "Manutenção Título".
export const CARACTERISTICA_MANUTENCAO_TITULO = 85;
export const RASTREAMENTO_TITULOS_PAGE_SIZES = [20, 50, 100];
// W-0587 — Relatório de Cidades por Região (reusa característica 19 do W-0525 — ADR-001)
export const CARAC_MANUTENCAO_CIDADES = 19;
export const ROUTE_RELATORIO_CIDADES_REGIAO =
  '/ges/relatorios/cidades-por-regiao';
// W-0599 — Histórico Padrão (sem RBAC no Delphi; rota/menu abertos para autenticados)
export const ROUTE_HISTORICO_PADRAO = '/ges/relatorios/historico-padrao';

// Char 630 — Homologador (gate universal de migração ERP→Web; remover quando tela liberar para uso geral)
// Originado em W-0588 (ADR-003); reusado por todos os WIDs migrados.
export const CARACTERISTICA_HOMOLOGADOR = 630;
// W-0743 — char 236 "Relatório Dados Cliente" (Imob > Relatórios > Administração > Atualização Cadastral Prefeitura/Água).
// Fonte: caracteristica_de_software.csv:234. Gate funcional da tela.
export const CARACTERISTICA_RELATORIO_DADOS_CLIENTE = 236;
// W-0744 — Fonte: caracteristica_de_software.csv:628.
export const CARACTERISTICA_RELATORIO_DEBITOS_MUNICIPAIS = 639;
// W-0556 — Estorna Proposta; usada apenas nas melhorias admin migradas.
export const CARACTERISTICA_ESTORNA_PROPOSTA = 39;
export const ROUTE_RELATORIO_RAMOS = '/relatorios/ges/contas/ramo';

// Gerador de Assinatura de E-mail — migração de webforms-extranet/WebImob2015/Assinatura.aspx.
export const ROTA_GERADOR_ASSINATURA_EMAIL = '/ferramentas/assinatura-email';
// A tela não exige característica (qualquer usuário logado acessa); só o botão "Alterar Arte" é gated.
export const CARACTERISTICA_ALTERAR_ARTE_ASSINATURA = 720;

// W-0613 — Posição Sintética Carteira a Receber (Gate 1B Q-01=A). Acesso à tela inteira.
export const CARACTERISTICA_POSICAO_SINTETICA_CARTEIRA_RECEBER = 692;
export const ROUTE_POSICAO_SINTETICA_CARTEIRA_RECEBER =
  '/ges/gerencial/financas/posicao-sintetica-carteira-receber';

// W-0617 — Mapeamento Geral Estoque (ERP ges/UEstoque.pas). Sem RBAC: o ERP não controla
// acesso a esta tela (gate-1a) — tela autenticada simples, sem característica.
export const ROUTE_MAPEAMENTO_GERAL_ESTOQUE =
  '/ges/gerencial/estoque/mapeamento-geral-estoque';

// W-0526 — GES > Negócios > Autoriza Despesa/Projetos.
// Gate HML (PRD §3): char 630 (homologador) AND qualquer característica de aprovação —
// 165 (Autoriza Pagamento) / 258 (Aprovador Despesa) / 259 (Aprovador Master) / 265 (Autoriza Pagamento Gestor).
// Espelha ChavesController.TemAcessoAutorizaDespesa(). Char 21 ("Gerenciais Despesas") era de OUTRA
// tela (relatório) — handoff backend errado, causava lockout total (FE×BE divergentes).
export const CARACTERISTICAS_APROVACAO_DESPESA = [165, 265, 259, 258];
export const ROUTE_AUTORIZA_DESPESA = '/ges/negocios/autoriza-despesa';

// W-0928 — Relatório Audit: Contas sem saldo conferido (ADR-001 W-0928 char nova 660 + portão 630)
export const CARACTERISTICA_RELAT_CONTAS_SEM_SALDO_CONF = 660;
export const ROUTE_RELAT_CONTAS_SEM_SALDO_CONF =
  '/relatorios/audit/contas-sem-saldo-conferido';

// W-0691 — Atualiza Taxa de Transferência (Imob/Administração).
// Char 670 = "Atualiza Taxa Transferencia" conforme caracteristica_de_software.csv (fonte da verdade).
// Corrigido de 695 (placeholder) — 695 pertence a "Acesso Senha Aprovação". Ajustado 2026-06-03.
// BE controller checa AND [630, 670]. Char 630 = portão de migração (LICOES §1.8).
// [VALIDAR-DBA] confirmar que prod tem 670 cadastrada para esta tela antes do go-live.
export const CARACTERISTICA_ATUALIZA_TAXA_TRANSFERENCIA = 670;

// W-0645 — Parâmetros do sistema > Fusão (reusa caracteristicas.Sis_parametros = 18; char 630 = gate de migração LICOES §1.8)
export const ROUTE_PARAMETROS_SISTEMA_FUSAO =
  '/ges/ferramentas/parametros-sistema/fusao';

// DW-0999 — Parâmetros > Contatos de Teste (característica 725)
export const CARACTERISTICA_CONTATOS_TESTE = 725;
export const ROUTE_PARAMETROS_CONTATOS_TESTE =
  '/configuracoes/parametros/contatos-teste';

// W-0683 — Local de Atendimento (Imob). Char 381 confirmada via UPrincipal.pas:7554.
export const CARACTERISTICA_LOCAL_ATENDIMENTO = 381;

// W-0634 — Manual de Apuração de Resultados (escrita gated por CARACTERISTICA_HOMOLOGADOR=630)
export const ROUTE_MANUAL_APURACAO = '/gerencial/manual-apuracao';

// W-0593 — Relatório de Centro de Custo — [VALIDAR-TSETCORP: alocar característica nova]
export const CARACTERISTICA_REL_CENTRO_CUSTO = -1; // [VALIDAR-DBA] sentinel; -1 dispara Forbidden() até DBA cadastrar
export const ROUTE_REL_CENTRO_CUSTO = '/ges/relatorios/contas/centro-custo';

// W-0627 — Relatório Carteira por Conta Capital — [VALIDAR-TSETCORP: alocar característica nova]
export const CARACTERISTICA_CARTEIRA_CONTA_CAPITAL = -1; // [VALIDAR-DBA] sentinel; -1 dispara Forbidden() até DBA cadastrar
export const ROUTE_CARTEIRA_CONTA_CAPITAL =
  '/ges/relatorios/carteira/conta-capital';

// W-0779 — Relatório Razão Social (Imob > Relatórios > Contábil) — composição societária CFC.
// RBAC característica 694 "Relatorio_Razao_Social" (Q-01=A; dados sensíveis CNPJ/sócios/capital).
// [VALIDAR-TSETCORP: confirmar 694 alocada em caracteristica_de_software e exposta no payload].
export const CARACTERISTICA_RELATORIO_RAZAO_SOCIAL = 694;
export const ROUTE_RELATORIO_RAZAO_SOCIAL = '/imob/relatorios/contabil/razao-social';
export const RAZAO_SOCIAL_STATUS = ['A', 'E', 'P', 'G']; // Ativa, Encerrada, Pré-Ativa, Gerencial
export const RAZAO_SOCIAL_TIPO_PARTICIPACAO = ['100', 'com_outros', 'sem']; // rgTipoParticipacao
export const RAZAO_SOCIAL_TIPO_RELATORIO = ['analitico', 'sintetico']; // rgTipoRelatorio
export const RAZAO_SOCIAL_ORDEM = ['razao_social', 'ge_e_razao_social']; // rgOrdem

// W-0724 — Portador Jurídico (Imob) — Gate 1B: 640 Portador Juridico
export const CARACTERISTICA_PORTADOR_JURIDICO = 640;
export const ROUTE_PORTADOR_JURIDICO = '/imob/juridico/portador-juridico';

// W-0663 — Acerta contas de despesas/receitas (Ferramenta GES)
// Char 645 "Acerta Codigo Despesa" — paridade UAcertacodigoconta.pas. Gate transitório com 630 (Setpar §1.8).
export const CARACTERISTICA_ACERTAR_CONTA = 645;
export const ROUTE_ACERTAR_CONTA = '/ges/ferramentas/acertar-conta';

// W-0651 — Altera Código Conta (Ferramenta GES, destrutiva). Char 31 "Alterar Codigo Conta"
// compartilhado com MODULO CAMBIO (gate-1b Q-02=A). Gate transitório com 630 (LICOES §1.8).
export const CARACTERISTICA_ALTERAR_CODIGO_CONTA = 31;
export const ROUTE_ALTERAR_CODIGO_CONTA = '/ges/ferramentas/alterar-codigo-conta';
export const MODOS_BUSCA_CONTA = ['codigo', 'apelido'];
export const MSG_SUCESSO_ALTERACAO = 'Registros lançados com sucesso.'; // literal Delphi

// W-0654 — Altera Código Departamento (Ferramenta GES, irreversível). Característica NOVA 677
// "Alterar Codigo Depto" (gate-1b Q-01=A — DDL pendente). Gate de visibilidade HML com 630 (LICOES §1.8).
export const CARACTERISTICA_ALTERAR_CODIGO_DEPARTAMENTO = 677;
export const ROUTE_ALTERAR_CODIGO_DEPARTAMENTO =
  '/ges/ferramentas/alterar-codigo-departamento';
export const MSG_SUCESSO_ALTERACAO_DEPARTAMENTO =
  'Departamento alterado com sucesso.'; // sucesso reescrito (tom Web, Q-05=C)

// W-0553 — Estorno de baixa de títulos (reusa característica 66 "Intercambio" — ADR-001).
// Gate de migração via CARACTERISTICA_HOMOLOGADOR=630 (LICOES §1.8) — remover na promoção HML→DONE.
export const CARACTERISTICA_ESTORNO_TITULO = 66;
export const LIMITE_LOTE_ESTORNO = 200;
export const ROUTE_ESTORNO_BAIXA_TITULO = '/ges/titulos/estorno';

// W-0664 — Fechamento de Caixa (GES > Ferramentas) — característica 191 ("Fecha Caixa")
export const CARACTERISTICA_FECHA_CAIXA = 191;
export const ROUTE_FECHAMENTO_CAIXA = '/ges/fechamento-caixa';

// W-0607 — Consulta Aniversariantes (read-only). Gate AND: char 630 (migração, canonical
// CARACTERISTICA_HOMOLOGADOR) + char 647 (Consulta Aniversariantes/LGPD). Espelha
// AniversariantesController.PossuiPermissao() (630 && 647). 647 é valor real atribuído
// no backend; enquanto o DBA não cadastrar 647 para o usuário, menu/rota ficam ocultos
// (comportamento esperado — LICOES §1.8: remover gate 630 na promoção HML→DONE).
export const CARACTERISTICA_CONSULTA_ANIVERSARIANTES = 647;
export const ROUTE_CONSULTA_ANIVERSARIANTES = '/ges/consultas/aniversariantes';

// W-0726 — Contas Isentas Jurídico (Imob) — ADR-001: reusa característica 95 "Acesso Juris"
export const ROUTE_CONTAS_ISENTAS_JURIDICO = '/juridico/contas-isentas';

// W-0684 — Tipo de Atendimento (Imob)
export const TIPO_ATENDIMENTO_CARACTERISTICA = 380;

// W-0579 — Relatório de Cheques Devolvidos (ADR-002: sem authorizationEvaluator)
export const ROUTE_RELATORIO_CHEQUES_DEVOLVIDOS =
  '/ges/relatorios/titulos/cheques-devolvidos';

// W-0590 - Relatorio Plano de Contas
export const ROUTE_RELATORIO_PLANO_CONTAS =
  '/financeiro/relatorio-plano-contas';
export const REPORT_SERVER_BASE_URL =
  process.env.REACT_APP_REPORT_SERVER_URL || gerarAmbienteUrl(true);

// W-0825 — Clientes Isentos de Cobrança (Imob > Cobrador) — ADR-001: reusa caract 86 "Cobranca Imovel"
export const COBRANCA_IMOVEL = 86;

// W-0821 — Transferir títulos para cobrança (Imob > Cobrador)
// Gate 1B Q-01 (answered choice A): 125 OR 126 dão acesso à tela; 95 filtra cobradores tipo 3/4/5
// CARACTERISTICA_HOMOLOGADOR (630) já definido acima — portão de migração (LICOES §1.8)
export const CARACTERISTICA_COBRADOR_GERENCIAL = 125;
export const CARACTERISTICA_COBRADOR_OPERACIONAL = 126;
export const CARACTERISTICA_ACESSO_JURIS = 95;
export const GES_EXCLUIDOS_COBRANCA = [252, 508];
export const LIMITE_LOTE_BOLETOS = 200;
export const ROUTE_TRANSF_COBRANCA = '/imob/cobrador/transferir-titulos';

// W-0489 — Consulta de Ocorrências de Ativos (ERP→Web).
// Paridade Delphi: tela aberta a qualquer usuario autenticado (ProjetoMAIN.PAS:4685
// nao chama AutorizaUsuario). Sem caracteristica granular — apenas char 630
// (CARACTERISTICA_HOMOLOGADOR) atua como portao de migracao HML (LICOES §1.8),
// removida na promocao HML→DONE.
export const ROUTE_CONSULTA_OCORRENCIAS_ATIVO =
  '/ges/consultas/ocorrencias-ativo';

// W-0490 — Transferência de Ocorrências entre Contas (GES > Ferramentas) — [VALIDAR-TSETCORP: alocar característica nova — Assumpcao-A1]
// Char 630 (CARACTERISTICA_HOMOLOGADOR) atua como portão de migração até liberação geral (LICOES §1.8)
export const CARACTERISTICA_TRANSFERENCIA_OCORRENCIAS = -1; // [VALIDAR-DBA] sentinel; -1 dispara Forbidden() até DBA cadastrar
export const ROUTE_TRANSFERENCIA_OCORRENCIAS =
  '/ges/ferramentas/transferencia-ocorrencias';

// W-0713 — Gerenciamento de E-mail (Imob > Comercial)
export const MENU_GERENCIA_EMAIL = 638;

// W-0527 — Cadastro de Cartão de Crédito
export const CARACTERISTICA_CARTAO_CREDITO = 506;

export const StatusContratoCEDOC = {
  Pendente: 0,
  Recebido: 1,
  Aprovado: 2,
  Recusado: 3,
};

export const DESCRICOES_STATUS_CEDOC = [
  { value: 0, label: 'Pendente', cor: '#FFC107' },
  { value: 1, label: 'Recebido', cor: '#17A2B8' },
  { value: 2, label: 'Aprovado', cor: '#28A745' },
  { value: 3, label: 'Recusado', cor: '#DC3545' },
];
/**
 * @description Objeto(enum) que guarda os status do bando de dados da venda com condição especial
 */
export const CondicoesEspeciaisStatus = {
  //O status 0 é apenas usado no front
  SemStatus: 0,
  PendenteGerente: 1,
  PendenteDiretoria: 2,
  Contraproposta: 3,
  SolicitacaoAprovada: 4,
  SolicitacaoRecusada: 5,
};

/**
 * @description Tipos de parcela que são usadas no formulário da venda
 */
export const TiposParcelasFinanciamento = {
  Financiamento: 'Financiamento',
  Intermediaria: 'Intermediária',
  Programadas: 'Programada',
  Condicionante: 'Condicionante',
};

export const TipoComissao = {
  RetidaCorretor: 1,
  ComissaoContrato2: 7,
};

export const DIAS_SEMANA = [
  'Domingo',
  'Segunda',
  'Terça',
  'Quarta',
  'Quinta',
  'Sexta',
  'Sábado',
];
export const MESES = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

const {
  novo_lead,
  qualificacao,
  requalificacao,
  recepcao_corretor,
  em_atendimento,
  visita,
  montagem_de_pasta,
  pasta_completa,
  venda_realizada,
  descartado,
  reativacao,
  pre_lancamento,
  fila_do_lote,
} = PROSPECTO_STATUS_ENUM;

// Lista dinâmica com todos os códigos de etapas definidos nas colunas
const TODOS_STATUS_PROSPECTO = STATUS_ETAPAS_PROSPECTOS.map(s => s.codigo);

export const REGRA_FLUXOGRAMA_ETAPA = TODOS_STATUS_PROSPECTO.reduce(
  (regra, codigo) => {
    if (codigo === PROSPECTO_STATUS_ENUM.descartado) {
      // Exceção: ao sair de "Descartado" só pode ir para estes
      regra[codigo] = [
        PROSPECTO_STATUS_ENUM.montagem_de_pasta,
        PROSPECTO_STATUS_ENUM.em_atendimento,
        PROSPECTO_STATUS_ENUM.reativacao,
      ];
    } else {
      // De qualquer outra etapa, pode ir para qualquer etapa (exceto a mesma)
      regra[codigo] = TODOS_STATUS_PROSPECTO.filter(c => c !== codigo);
    }
    return regra;
  },
  {}
);
export const CanalAtendimento = {
  Outros: 'O',
  Extranet: 'X',
  Chatbot: 'B',
  ZendeskChatWidget: '1',
  ZendeskWhatsApp: '2',
  ZendeskEmail: '3',
  ZendeskFormulario: '4',
  ZendeskFacebookMessenger: '5',
  Ouvidoria: '6',
  App: '7',
  ZendeskTelefone: '8',
  Telefone: 'T',
  URA: 'U',
  ReclameAqui: 'A',
  ChatBlip: 'C',
  Email: 'E',
  BackOffice: 'I',
  Implantacao: 'M',
  Interno: 'N',
  Presencial: 'P',
  RedeSocial: 'R',
  AreaDoCliente: 'S',
  Whatsapp: 'W',
};

export const TipoOperacao = {
  Inserir: 0,
  Atualizar: 1,
  Excluir: 2,
};

export const getCanalNome = canalDb => {
  switch (canalDb) {
    case 'O':
      return 'Outros';
    case 'X':
      return 'Extranet';
    case 'B':
      return 'Chatbot';
    case '1':
      return 'Zendesk Chat Widget';
    case '2':
      return 'Zendesk WhatsApp';
    case '3':
      return 'Zendesk Email';
    case '4':
      return 'Zendesk Formulário';
    case '5':
      return 'Zendesk Facebook Messenger';
    case '6':
      return 'Ouvidoria';
    case '7':
      return 'App';
    case '8':
      return 'Zendesk Telefone';
    case 'T':
      return 'Telefone';
    case 'U':
      return 'URA';
    case 'A':
      return 'Reclame Aqui';
    case 'C':
      return 'Chat Blip';
    case 'E':
      return 'Email';
    case 'I':
      return 'Back Office';
    case 'M':
      return 'Implantação';
    case 'N':
      return 'Interno';
    case 'P':
      return 'Presencial';
    case 'R':
      return 'Rede Social';
    case 'S':
      return 'Área do Cliente';
    case 'W':
      return 'WhatsApp';
    default:
      return 'Outros';
  }
};

// W-0718 — Gestão IPTU
export const GESTAO_IPTU = 685;
// W-0718 — Subtela D5: replica AutorizaUsuario('Cad Conta Prefeitura') de UImovelCarne.pas:501.
// Código numérico provisional (DOSSIE_D5 menciona 541 sem evidência verbatim — confirmar em UAT).
export const CAD_CONTA_PREFEITURA = 541;

// W-0503 — GES Matricial de Despesas
export const MATRICIAL_CONTROLADORIA = 261;
// W-0570 — GES Matricial de Despesas — Períodos
export const CARACTERISTICA_GERENCIA_ORCAMENTO_MATRICIAL = 260;
// W-0551 — GES Baixa de Títulos
export const CARACTERISTICA_BAIXA_TITULO = 635;
// W-0962 — Controle de Contrato
export const STATUS_CONTRATO = {
  1: 'Não Enviados',
  2: 'Já Enviados',
  3: 'Já Retornados',
  4: 'Assinado Diretoria',
  5: 'Assinaturas Finalizadas',
  6: 'Quitado Recurso Próprio',
  7: 'Quitado Autorização de Escritura',
  8: 'Quitado Autorização de Escritura + Procuração',
  9: 'Escritura Lavrada Digitalizada',
  10: 'Finalizado Escritura Lavrada e Registrada',
  11: 'Finalizado Financiamento Bancário/Consórcio',
  12: 'Confissão de Dívida',
};

// W-0563 — Cadastro de Cartões (operadoras + taxas por GE) — char 630 portão de migração
export const CADASTRO_CARTAO_TAXA = 643;

export const STATUS_BADGE_COLOR = {
  1: 'secondary',
  2: 'info',
  3: 'info',
  4: 'primary',
  5: 'primary',
  6: 'success',
  7: 'success',
  8: 'success',
  9: 'success',
  10: 'success',
  11: 'success',
  12: 'warning',
};

// W-0564 — Cadastro de Templates de Rateio (ADR-001 — TEMP: reavaliar granularidade)
// TEMP W-0564 ADR-001 — reavaliar granularidade
export const CARACTERISTICA_RATEIO_TEMPLATE = 152;

// W-0879 — Processar Retorno Cobrança BRADESCO sem registro
export const CARACTERISTICA_RETORNO_BRADESCO = 693;
export const RETORNO_COBRANCA_BRADESCO = '/generate/retorno-cobranca-bradesco';

// W-0882 — Retorno Cobrança - Geral (CEF/BRADESCO/TIVIT/SANTANDER)
// Char 630 (CARACTERISTICA_HOMOLOGADOR) é portão de migração — LICOES §1.8/ADR-007
export const RETORNO_COBRANCA_GERAL = '/ges/retorno-cobranca';

// W-0872 — Relatório Remessa de Boletos — char 630 portão de migração (LICOES §1.8)
export const CARACTERISTICA_RELATORIO_REMESSA_BOLETOS = 631;
export const ROUTE_RELATORIO_REMESSA_BOLETOS =
  '/generate/relatorios/remessa-boletos';

// W-0710 — Cancelar Proposta Mista (Imob > Comercial) — característica "Efetiva Cancelamento"
export const CARACTERISTICA_CANCELA_PROPOSTA_MISTA = 266;

// W-0840 — Pro-Fit > Relatórios > Comissão de Imóveis (ADR-001 — característica dedicada 652)
export const CARACTERISTICA_RELAT_COMISSAO_IMOVEIS = 652;

// W-0560 — Reapresentação de Cheques Devolvidos (ADR-002)
// [VALIDAR-DBA] sentinel; -1 dispara Forbidden() até DBA cadastrar valor real
export const CARAC_REAPRESENTAR_CHEQUES = -1;

// W-0881 — Conciliação Bancária - Geral (Generate > Retorno). 630 reusa CARACTERISTICA_HOMOLOGADOR (portão migração — LICOES §1.8).
export const CARACTERISTICA_CONCILIACAO_BANCARIA = 662;
export const ROUTE_CONCILIACAO_BANCARIA =
  '/generate/retorno/conciliacao-bancaria';

// W-0698 — Imob/Administração/Monitoramento de clientes
export const CARACTERISTICA_MONITORAMENTO = 203;
export const LIMITE_LOTE_BOLETOS_MONITORA = 100;
export const PARAM_DIAS_MONITORA_FALLBACK = 30;

// W-0733 — Ata Contábil (Imob > Contábil) — característica "Ata Reuniao"
export const CARACTERISTICA_ATA_CONTABIL = 252;

// W-0539 — Contas Prefeitura Sem Convênio (GES > Ferramentas)
// Inspeção do Delphi (uContaPrefeituraSemConvenio.pas + ProjetoMAIN.PAS:4366-4372) confirmou
// que a tela NÃO tinha RBAC algum (sem AutorizaUsuario, sem PossuiCaracteristica, menu sem
// trava). Aplicado pattern operador W-0490: durante HML, apenas char 630
// (CARACTERISTICA_HOMOLOGADOR / caracteristicas.MigracaoERP) gateia FE e BE. Sem característica
// granular dedicada. Menu/rota usam diretamente CARACTERISTICA_HOMOLOGADOR.
export const ROUTE_CONTAS_PREFEITURA_SEM_CONVENIO =
  '/ges/contas/contas-prefeitura-sem-convenio';
// Lista de tipos elegíveis de Contas (ADR-005 — preservada 1:1 do Delphi pas:215 até ENUM-CHECK).
export const TIPOS_CONTA_PREFEITURA_SEM_CONVENIO = '2,3,4,5,6,7,8';

// W-0771 — Relatório Vendas com Desconto (Imob > Comercial > Vendas)
// Sem característica específica — gate-intent choice A (paridade ERP, somente autenticado)
export const ROUTE_RELATORIO_VENDAS_DESCONTO = '/relatorio-vendas-desconto';

// W-0935 — Cheques Prorrogados (módulo Auditoria). Char 100 = "Auditoria" (compartilhada).
// Char 630 (portão de migração) reusa CARACTERISTICA_HOMOLOGADOR já declarado acima.
export const CARACTERISTICA_AUDITORIA = 100;
export const ROUTE_CHEQUES_PRORROGADOS = '/audit/cheques-prorrogados';
// W-0937 — Histórico de Imóveis (módulo Auditoria). Reusa char 100 (Auditoria) + 630 (portão de migração).
export const ROUTE_HISTORICO_IMOVEIS = '/relatorios/audit/historico-imoveis';

// W-0858 — Relacionamento de Contas (Generate > Manutenção)
// Característica 708 — Generate Manutenção.
// 695 era placeholder mas pertence a "Acesso Senha Aprovação".
// Compartilhada W-0855/0856/0857/0858; ADR-001 gate-1b choice A.
export const CARACTERISTICA_GENERATE_MANUTENCAO = 708;
export const ROUTE_RELACIONAMENTO_CONTAS = '/generate/relacionamento-contas';

// W-0540 — Saldos de Contas (GES > Contas > Saldos de Contas)
// ⚠️ [COLISAO-631] Valor 631 já declarado como CARAC_CONSULTA_OCORRENCIAS_ATIVO (W-0489) e
//   CARACTERISTICA_RELATORIO_REMESSA_BOLETOS (W-0872). DBA deve confirmar qual demanda recebe 631
//   e reatribuir as demais. Ver MEMORY.md §Blockers.
// ⚠️ DBA deve executar INSERT em caracteristica_de_software (id=631) antes do deploy.
// Char 630 (CARACTERISTICA_HOMOLOGADOR) é portão de migração (LICOES §1.8) — remover na promoção.
export const CHAR_SALDO_CONTAS_CONFERIR = 631;
export const ROUTE_SALDOS_CONTAS = '/ges/saldos-contas';

// W-0657 — Lista de E-mail de Clientes (GES > Ferramentas).
// ADR-001: sem RBAC funcional — fiel ao ERP (UListaEmail.pas sem AutorizaUsuario).
// Char 630 (CARACTERISTICA_HOMOLOGADOR) aplicado nas 3 camadas como gate de migração HML.
export const ROUTE_LISTA_EMAIL_CLIENTES =
  '/ges/ferramentas/lista-email-clientes';

// Comunicado Email — tela genérica de envio em massa via planilha.
export const CARAC_COMUNICADO_EMAIL = 672;
// DW-0996 — Sistema RSVP Eventos (Admin no CRM, gated por Marketing)
// ADR-002: CRUD admin no CRM, char 671 exclusiva, JWT do CRM (não token público).
export const CARACTERISTICA_EVENTO_RSVP = 671;

// W-0531 — Solicita Reembolso Clientes (IPTU) — Imob > Administração
// 666: portão de acesso à tela; 576: permite lançar mesmo com chaves não pagas.
export const CARACTERISTICA_IMPLANTA_REEMBOLSAVEIS = 666;
export const CARACTERISTICA_REEMBOLSO_LIBERADO = 576;

export const ROUTE_EVENTOS_RSVP = '/marketing/eventos-rsvp';

// DW-0998 — "Checkin/Pesquisa Evento Entrega": acesso restrito (mesma lógica da 501
// "Somente Sismac"). Usuário com 687 NÃO vê nada além das telas de Check-in e Pesquisa
// de Evento — é rejeitada nos menus comerciais como a 501, e exclui também o Sismac.
export const CARACTERISTICA_CHECKIN_PESQUISA_EVENTO = 687;

// DW-0998 — Pesquisas Entrada/Saída do Evento de Entrega SetGarden (família 11384).
// Tela interna do atendente. Gating = isAdm (claim is_adm do JWT), sem característica nova.
export const ROUTE_PESQUISA_EVENTO = '/marketing/pesquisa-evento';

// DW-0998 — Check-in de Evento (portaria/recepção). Reusa CARACTERISTICA_EVENTO_RSVP (671)
// para gate, conforme alinhamento com Marketing — quem opera o RSVP opera o check-in.
export const ROUTE_EVENTO_RSVP_CHECKIN = '/marketing/evento-rsvp/checkin';

// W-0491 — Lista de Ocorrências de Contas (GES > Relatórios > Contas)
// RBAC: rota e card de menu restritos a admin via AuthStorage.isADM() — Gate 1B Q-01=E
// (SEM característica numérica). Negação no backend retorna 400 (SEC-005), nunca 403.
export const ROUTE_RELATORIO_OCORRENCIAS_CONTAS = '/ges/relatorios/contas/ocorrencias';
export const PAGE_SIZE_DEFAULT_OCORRENCIAS = 20;
export const MAX_EXCEL_ROWS_OCORRENCIAS = 50000;
export const ORDENS_OCORRENCIAS_OPTIONS = [
  { value: 'data_desc', label: 'Data (mais recente primeiro)' },
  { value: 'data_conta', label: 'Data + Conta' },
  { value: 'conta_data', label: 'Conta + Data' },
];

// W-0543 — Contas de Difícil Liquidação (GES > Contas > Tabelas)
// Char 630 (CARACTERISTICA_HOMOLOGADOR) como portão de migração HML (LICOES §1.8) — remover na promoção.
export const CARACTERISTICA_CONTAS_DIF_LIQ = 73; // Titulo Inadimplencia
export const ROUTE_CONTAS_DIF_LIQ = '/ges/contas-tabelas/dificil-liquidacao';

// W-0547 — Importação XLS de Contas (GES > Contas > Manutenção de Contas)
// Char 630 (CARACTERISTICA_HOMOLOGADOR) actua como portão de migração HML até liberação geral (LICOES §1.8).
export const CARACTERISTICA_IMPORTACAO_XLS_CONTAS = 641;

// W-0595 — GES > Relatórios > Negócios > Lista de Negócios (read-only).
// Backend RelNegociosController.TemAcesso() enforça o PAR: char 630 (portão de migração,
// CARACTERISTICA_HOMOLOGADOR — já declarado) AND char 83 (acesso Negócio, reuso Gate 1A Q-01).
// O char 14 "Libera Extrato" (CARACTERISTICA_EXTRATO_CUSTODIA — já declarado) é só server-side
// (oculta contas sigilosas do extrato); o FE não gateia por ele.
export const CARACTERISTICA_REL_NEGOCIOS_ACESSO = 83; // char "Negócio" (Gate 1A Q-01)
export const ROUTE_REL_NEGOCIOS = '/ges/relatorios/negocios/lista';

// W-0600 — Relatório de Digitalizações (read-only; gate por AuthStorage.isADM, sem característica)
export const ROUTE_RELATORIO_DIGITALIZACOES = '/relatorios/digitalizacoes';

// W-0829 — Resultado de Atendimento (Cobrador) — CRUD mestre/detalhe Tipo + SubTipo.
// Fonte Delphi: UResultadoAtend.pas (TFResultadoAtend). Backend: cobrador/resultado-atendimento (sem "api/").
// RBAC: característica 291 'Resultado Atendimento' (operador cravou 291; NÃO 314 — duplicata do CSV;
// DBA confirma canônico na Fase 4). Negação no backend = 400 (NÃO 403 — SEC-005).
export const RBAC_RESULTADO_ATENDIMENTO = 291;
export const ROUTE_RESULTADO_ATENDIMENTO = '/imob/cobrador/resultado-atendimento';
export const RESULTADO_ATEND_PAGA_OPCOES = [
  { value: 'S', label: 'Sim' },
  { value: 'N', label: 'Não' },
];
export const MSG_OPERACAO_CONCLUIDA = 'Operação concluída.'; // literal Delphi (sucesso SubTipo)

// W-0759 — Imóveis em Estoque (Relatório Comercial Imob).
export const ROUTE_IMOVEIS_ESTOQUE = '/relatorios/imoveis-estoque';
// W-0604 — GES Etiquetas/Cartas (migração TFEtiqueta / UEtiqueta.pas)
// Char 236 = "Relatório Dados Cliente" (emissão em lote); char 240 = "Etiqueta Avulsas".
// Gate de tela: 236. Botões avulsa/selecionar: OR(236, 240).
export const CARACTERISTICA_RELATORIO_CONTAS = 236;
export const CARACTERISTICA_ETIQUETA_AVULSA = 240;
export const ROUTE_ETIQUETAS_CARTAS = '/ges/etiquetas-cartas';
